// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#img-404[data-v-2caee459]{opacity:.3;width:75%}", "",{"version":3,"sources":["webpack://./resources/js/pages/frontend/404.vue"],"names":[],"mappings":"AAaA,0BAEE,UAAA,CADA,SAXF","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n#img-404 {\n  width: 75%;\n  opacity: 0.3;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
